"use client";

import { WlkpCompanyEmployerBasicRegistrationDto } from "@entities/employer";
import { WlkpCompanyEmployerBasicDetails, WlkpCompanyEmployerBasicRegistrationForm } from "@features/registration";
import { Button, Dialog, DialogBody, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

function EditDialog({
  payload,
  onSubmit,
}: {
  payload?: WlkpCompanyEmployerBasicRegistrationDto | null;
  onSubmit?: (payload: WlkpCompanyEmployerBasicRegistrationDto) => void;
}) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSubmit = (data: WlkpCompanyEmployerBasicRegistrationDto) => {
    if (onSubmit) {
      setIsOpen(false);
      onSubmit(data);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <DialogTrigger asChild>
        <Button className="text-sm font-bold m-0 p-0 w-auto h-auto" variant="link">
          Ubah
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit informasi dasar</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <WlkpCompanyEmployerBasicRegistrationForm formValue={payload || undefined} onSubmit={handleSubmit}>
            <div className="sticky bottom-0 grid grid-cols-2 gap-3 bg-white py-6 mt-1">
              <DialogClose asChild>
                <Button className="text-sm font-bold" variant="outline">
                  Batal
                </Button>
              </DialogClose>
              <Button className="text-sm font-bold" variant="default">
                Simpan
              </Button>
            </div>
          </WlkpCompanyEmployerBasicRegistrationForm>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

export function WlkpCompanyEmployerBasicRegistrationPreview({
  basic,
  onSubmit,
}: {
  basic?: WlkpCompanyEmployerBasicRegistrationDto | null;
  onSubmit?: (payload: WlkpCompanyEmployerBasicRegistrationDto) => void;
}) {
  return (
    <div>
      <div className="mb-4 flex items-center gap-4">
        <h4 className="flex-1 text-base font-bold">Informasi dasar</h4>
        <EditDialog payload={basic} onSubmit={onSubmit} />
      </div>
      {basic && <WlkpCompanyEmployerBasicDetails basic={basic} />}
    </div>
  );
}
